import { useApp } from "../../context/AppContext.js";
import { EditClientModal } from "./EditClientModal.js";
import { AddClientModal } from "./AddClientModal.js";

export function Clients() {
  const {
    clients,
    showEditClient, setShowEditClient,
    showAddClient, setShowAddClient,
    handleSaveClient, handleAddClient, handleArchiveClient,
  } = useApp();

  const activeClients = clients.filter((c) => c.status === "active");
  const archivedClients = clients.filter((c) => c.status === "archived");

  const billingLabel = (type: string, rate: number) => {
    switch (type) {
      case "hourly": return `$${rate}/hr`;
      case "hourly_fixed": return `$${rate}/hr + fixed`;
      case "per_task_fixed": return "Per task + fixed";
      case "fixed_quarterly": return "Fixed quarterly";
      default: return type;
    }
  };

  return (
    <div>
      {showEditClient && (
        <EditClientModal
          client={showEditClient}
          onSave={handleSaveClient}
          onClose={() => setShowEditClient(null)}
          onArchive={() => handleArchiveClient(showEditClient.id)}
        />
      )}
      {showAddClient && (
        <AddClientModal
          onAdd={handleAddClient}
          onClose={() => setShowAddClient(false)}
        />
      )}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h3 className="section-title" style={{ margin: 0 }}>Active Clients ({activeClients.length})</h3>
        <button className="btn btn-primary btn-sm" onClick={() => setShowAddClient(true)}>+ Add Client</button>
      </div>

      <div className="client-grid">
        {activeClients.map((c) => (
          <div key={c.id} className="card client-card" onClick={() => setShowEditClient(c)}>
            <div className="client-avatar" style={{ background: c.color + "20", color: c.color }}>
              {c.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()}
            </div>
            <div>
              <div className="client-name">{c.name}</div>
              <div className="client-billing">{billingLabel(c.type, c.rate)}</div>
            </div>
          </div>
        ))}
      </div>

      {archivedClients.length > 0 && (
        <>
          <h3 className="section-title" style={{ marginTop: 32 }}>Archived ({archivedClients.length})</h3>
          <div className="client-grid">
            {archivedClients.map((c) => (
              <div key={c.id} className="card client-card archived" onClick={() => setShowEditClient(c)}>
                <div className="client-avatar" style={{ background: "#ccc", color: "#888" }}>
                  {c.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()}
                </div>
                <div>
                  <div className="client-name">{c.name}</div>
                  <div className="client-billing">{billingLabel(c.type, c.rate)}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
